'use client';

import useAccount from '@/lib/hooks/useAccount';
import useAccountRoles from '@/lib/hooks/useAccountRoles';

// EWM-653 — single source of truth for "can this user use Purchase Lists?".
// Purchase lists are Master-only (Luke, 2026-07-03), aligned with EWM-298's
// useRequireMaster: an authenticated user with the `UpdateMyCarts` permission.
// View-only users and guests get NO add-to-list action on ANY surface.
// EWM-644's Phase-2 perf gate consumes `canUsePurchaseLists` to decide whether
// to fetch wishlists at all.
const useShoppingListAccess = (businessUnitKey?: string): { canUsePurchaseLists: boolean; isLoading: boolean } => {
  const { account } = useAccount();
  const { permissions, isLoading } = useAccountRoles(businessUnitKey);

  const canUsePurchaseLists = !!account && !!permissions.UpdateMyCarts;

  return { canUsePurchaseLists, isLoading };
};

export default useShoppingListAccess;
